import { render } from "./CarDataStatistics.vue?vue&type=template&id=4e4fa56d"
import script from "./CarDataStatistics.vue?vue&type=script&lang=js"
export * from "./CarDataStatistics.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__